/* Modenaire press page, v3 (28 Sep 2026). Modelled on the flow of sobha-privy-collection.com: dark and cream chapters,
   script-and-capitals headlines, zoom-on-scroll photography, a line-drawn ribbon, and the edit as a curved WebGL
   gallery (three.js). Renders from window.PRESS exactly like v2, so one Shopify section can feed either design.
   Without WebGL, or for readers who ask for less motion, the gallery becomes a plain row of photos. */
(function () {
  const D = window.PRESS; if (!D) return;
  // One page, two audiences. The press wording below is the default; the creator page (AWIN program) sends its own
  // wording and a few setting changes as window.PRESS_VARIANT, laid over the top. Everything else is shared.
  const want = window.PRESS_PAGE;   // set by the Shopify section on /pages/creators: never show press wording there
  if (want && (!window.PRESS_VARIANT || window.PRESS_VARIANT.variant !== want)) return;
  const isObj = x => x && typeof x === 'object' && !Array.isArray(x);
  const merge = (a, b) => { for (const k in b) a[k] = isObj(a[k]) && isObj(b[k]) ? merge(a[k], b[k]) : b[k]; return a; };
  const PV = window.PRESS_VARIANT || {};
  if (PV.settings) merge(D.settings, PV.settings);
  if (PV.v3) merge(D.v3 || (D.v3 = {}), PV.v3);   // photo slots, e.g. the creator page's own Sharp Weather trio
  const COPY = {
    logo_sub: 'Press', logo_aria: 'Modenaire press, back to the top', hero_aria: 'Modenaire press',
    bar_link: 'Contact', hero_kicker: 'Modenaire press room',
    chapters: { edit: 'The fall edition', featured: 'Featured in', downloads: 'Press kit', about: 'About', samples: 'Samples and commission', contacts: 'Get in touch' },
    statement: ['Prices, sizes', 'and images,', 'ready for', 'your story'], statement_script: 'all in one place',
    mood_line: ['Tailored jackets, trench details and lace', 'for the turn of the season'],
    mood_link: { label: 'See the press kit', href: '#downloads' },
    kit_title: 'Press Kit', dl_linesheet: 'Line sheet', dl_factsheet: 'Fact sheet', csv_file: 'modenaire-press-pieces.csv',
    about_contact: 'Press',
    samples_title: ['Samples', 'of your choice,', 'in your size'],
    samples_cols: [
      { title: 'Samples', text: "We send samples of any product on this page in your size for editorial consideration, with no obligation to cover. Tell us what you like, and we'll send it.",
        link: { label: 'Request a sample', subject: 'Sample request', body: 'Piece:\nSize:\nColor:\nOutlet and story:\nPublish date:\nShipping address:\n' } },
      { title: 'Links and commission', text: "We're on AWIN, and Nordstrom. We offer {rate} commission on modenaire.com sales, as well as an exclusive {discount} discount for your readers just for you." }],
    piece_cta: { label: 'Request a sample', subject: 'Sample request: {piece}', body: 'Piece: {piece}\nSize:\nColor:\nOutlet and story:\nPublish date:\nShipping address:\n' },
    contacts_title: ['Get in', 'touch'],
    form_title: 'Reach out', form_button: 'Send', form_subject: 'Reach out, from the press page', form_handles: [],
    contact_row: true,   // the name / email / phone row in Get in touch
    testimonials: null,   // creator page: { label, title: [script, caps], items: [{ quote, name, handle }] }, shown before the last chapter
    statement_note: null,   // creator page: { label, big, line, text, link: { label, href } } in place of the statement's small photo; {lo} {hi} {top} are live prices
    apply: null,   // creator page: { title, note, href } shown instead of the form; title links to href once there is one
    join_form: null,   // creator page: { name, socials_legend, socials: [...], followers, button, note, subject, intro, need_social, need_handle } - a short form whose button opens a filled-in email; outranks apply
    form_legend: 'I cover:', form_topics: ['Fashion', 'Gift guides', 'Deals', 'TV'], form_other_aria: 'Other things you cover',
    footer: ['Where timeless', 'sophistication', 'meets modern', 'expression.'],
    linesheet_title: 'Line sheet, fall 2026', linesheet_contact: 'Press',
  };
  for (const k in PV.copy || {}) if (!(k in COPY)) console.warn('press page: unknown copy key "' + k + '"');
  const T = merge(JSON.parse(JSON.stringify(COPY)), PV.copy || {});
  const S = D.settings, V = D.v3 || {}, root = document.getElementById('press-root');
  const hidden = new Set(S.hide || []);   // section ids this page leaves out (their chapter goes from the menu too)
  const fill = (t, x = {}) => String(t).replace(/\{(\w+)\}/g, (m, k) => k in x ? x[k] : k === 'rate' ? S.earn.rate : k === 'discount' ? S.earn.reader_discount : m);
  root.classList.add('pr');
  if (PV.variant) root.dataset.page = PV.variant;   // lets the styles adjust one page, e.g. [data-page="creators"]
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const byHandle = Object.fromEntries(D.products.map(p => [p.handle, p]));
  // On Shopify the section also passes today's prices and stock from the Sharp Weather collection (window.PRESS_LIVE)
  // and the theme's addresses for the videos and PDFs (window.PRESS_MEDIA). A piece sold out in every size leaves the
  // lists; its photos can still appear in the page's image slots. Without either (the Vercel preview) nothing changes.
  const MEDIA = window.PRESS_MEDIA || {}, LIVE = window.PRESS_LIVE || {};
  ['hero_src', 'hero_video', 'hero_poster', 'hero_video_mobile', 'hero_poster_mobile', 'mood_video', 'mood_poster'].forEach(k => { if (V[k] && MEDIA[V[k]]) V[k] = MEDIA[V[k]]; });
  ['linesheet_url', 'factsheet_url'].forEach(k => { if (S[k] && MEDIA[S[k]]) S[k] = MEDIA[S[k]]; });
  if (Object.keys(LIVE).length) {
    const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '1X', '2X', '3X'], rank = s => ORDER.includes(s) ? ORDER.indexOf(s) : 99;
    D.products.forEach(p => {
      const l = LIVE[p.handle]; if (!l || !l.variants) return;   // not in the collection today: keep what the page was built with
      const si = (l.options || []).findIndex(o => String(o).toLowerCase() === 'size'), sz = {};
      if (si < 0) sz[(p.sizes[0] && p.sizes[0].size) || 'One size'] = l.variants.some(v => v[3]);
      else l.variants.forEach(v => { sz[v[si]] = sz[v[si]] || !!v[3]; });
      p.sizes = Object.entries(sz).sort((a, b) => rank(a[0]) - rank(b[0])).map(([size, available]) => ({ size, available }));
      p.price = l.price / 100; p.compare_at = (l.compare || 0) / 100; p.in_stock = l.variants.some(v => v[3]);
    });
    const prices = D.products.filter(p => p.in_stock).map(p => p.price);
    if (prices.length) D.price_range = [Math.min(...prices), Math.max(...prices)];
    D.size_range = [...new Set(D.products.filter(p => p.in_stock).flatMap(p => p.sizes.map(s => s.size)))].sort((a, b) => rank(a) - rank(b));
  }
  D.products = D.products.filter(p => p.in_stock);   // sold out in every size: off the lists (Shopify: as of today; preview: as of the build)
  const state = { edit: D.edits.some(e => e.slug === 'jackets') ? 'jackets' : 'all' };   // the gallery opens on the jackets
  const CHAPTERS = ['edit', 'featured', 'downloads', 'about', 'samples', 'contacts'].map(id => [id, T.chapters[id]])
    .filter(([id]) => (id !== 'featured' || S.featured_on) && !hidden.has(id));   // Featured in is hidden until there is coverage to show
  const chap = id => 'Chapter ' + (CHAPTERS.findIndex(c => c[0] === id) + 1);
  const ICON = {
    down: '<svg viewBox="0 0 10 16" width="10" height="16" aria-hidden="true"><path d="M5 0v15M1 11l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
    up: '<svg viewBox="0 0 10 16" width="10" height="16" aria-hidden="true"><path d="M5 16V1M1 5l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
    right: '<svg viewBox="0 0 16 10" width="16" height="10" aria-hidden="true"><path d="M0 5h15M11 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
    left: '<svg viewBox="0 0 16 10" width="16" height="10" aria-hidden="true"><path d="M16 5H1M5 1L1 5l4 4" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  };

  // ---------- helpers ----------
  const el = (tag, attrs = {}, ...kids) => {
    const n = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
      if (v == null || v === false) continue;
      if (k === 'class') n.className = v;
      else if (k.startsWith('on')) n.addEventListener(k.slice(2), v);
      else n.setAttribute(k, v === true ? '' : v);
    }
    for (const c of kids.flat(Infinity)) if (c != null && c !== false) n.append(c.nodeType ? c : txt(String(c)));
    return n;
  };
  // [placeholders] are highlighted so nothing unfinished goes live unnoticed
  const txt = s => {
    if (!/\[[^\]]+\]/.test(s)) return document.createTextNode(s);
    const f = document.createDocumentFragment();
    s.split(/(\[[^\]]+\])/).forEach(part => { if (part) f.append(/^\[[^\]]+\]$/.test(part) ? el('span', { class: 'ph' }, document.createTextNode(part)) : document.createTextNode(part)); });
    return f;
  };
  const icon = k => { const s = document.createElement('span'); s.className = 'ico'; s.innerHTML = ICON[k]; return s; };
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const pad = n => String(n).padStart(2, '0');
  const WORDS = ['No', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve'];
  const word = n => WORDS[n] || String(n);
  const money = n => '$' + (Number.isInteger(n) ? n : n.toFixed(2));
  const slug = s => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const role = (p, r) => { const i = (p.roles || {})[r]; return i == null ? null : p.images[i] || null; };
  const leadImg = p => role(p, 'lead') || p.images[0];   // lifestyle first
  const flatImg = p => role(p, 'flat') || leadImg(p);     // the product on its own
  const src = (im, w) => im.src + '?width=' + w;
  const pick = key => { const v = V[key]; const p = v && byHandle[v[0]]; return p && p.images[v[1]] ? { p, im: p.images[v[1]] } : null; };
  const fabric = p => (p.fabric || '').replace(/^MAIN:\s*/i, '').replace(/,?\s*LINER:.*$/i, '');
  const listJoin = a => a.length > 1 ? a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1] : a.join('');
  const split = s => { const w = s.split(' '); return [w.slice(0, -1).join(' '), w[w.length - 1]]; };
  const tt = (tag, script, caps, attrs = {}) => el(tag, Object.assign({ class: 'tt' }, attrs), script && el('span', { class: 'script' }, script), el('span', { class: 'caps' }, caps));
  const editNames = p => p.edits.map(s => (D.edits.find(e => e.slug === s) || {}).name).filter(Boolean).join(', ');
  const inStock = p => p.sizes.filter(s => s.available).map(s => s.size);
  const sizesNode = p => inStock(p).join(' ');
  const topPx = () => parseFloat(getComputedStyle(root).getPropertyValue('--pr-top')) || 0;
  const toast = msg => { const t = el('div', { class: 'toast', role: 'status' }, msg); root.append(t); setTimeout(() => t.remove(), 2400); };
  async function copy(text, label) {
    try { await navigator.clipboard.writeText(text); toast(label + ' copied'); }
    catch (e) { const ta = el('textarea', {}, text); document.body.append(ta); ta.select(); try { document.execCommand('copy'); toast(label + ' copied'); } catch (err) { toast('Select the text and copy it by hand'); } ta.remove(); }
  }
  function save(blob, name) {
    const a = el('a', { href: URL.createObjectURL(blob), download: name }); document.body.append(a); a.click();
    setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
  }
  async function downloadImage(img) {
    try { save(await (await fetch(img.src)).blob(), img.name); } catch (e) { window.open(img.src, '_blank', 'noopener'); }
  }
  async function downloadZip(products, name) {
    if (!window.JSZip) { products.forEach(p => p.images.forEach(downloadImage)); return; }
    toast('Preparing your download');
    const zip = new JSZip();
    for (const p of products) {
      const folder = products.length > 1 ? zip.folder(slug(p.short)) : zip;
      await Promise.all(p.images.map(async im => { try { folder.file(im.name, await (await fetch(im.src)).blob()); } catch (e) {} }));
    }
    save(await zip.generateAsync({ type: 'blob' }), name);
  }
  const zipOne = p => downloadZip([p], `modenaire-${slug(p.short)}-images.zip`);
  const mail = (to, subject, body) => `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  const sampleMail = p => mail(S.contact.email, fill(T.piece_cta.subject, { piece: p.short }), fill(T.piece_cta.body, { piece: p.short }));
  // creator page: name, a tick and a handle for each account, and an estimate of followers; the button opens an email with it all filled in
  function joinForm(J) {
    const at = v => /[/.]/.test(v) ? v : '@' + v.replace(/^@+/, '');   // a pasted profile link stays as it is
    const clear = f => f.querySelectorAll('input').forEach(x => x.setCustomValidity(''));
    const sync = row => row.classList.toggle('on', row.querySelector('input[type=checkbox]').checked);
    return el('form', { class: 'join', novalidate: true, oninput: e => clear(e.currentTarget), onchange: e => clear(e.currentTarget),
      onsubmit: e => { e.preventDefault(); const f = e.target;
        const name = f.querySelector('input[name=name]'), fol = f.querySelector('input[name=followers]');
        const rows = [...f.querySelectorAll('.j-social')], on = rows.filter(r => r.querySelector('input[type=checkbox]').checked);
        const bad = (x, msg) => { x.setCustomValidity(msg); x.reportValidity(); };
        if (!name.value.trim()) return bad(name, 'Add your name');
        if (!on.length) return bad(rows[0].querySelector('input[type=checkbox]'), J.need_social);
        const blank = on.find(r => !r.querySelector('input.handle').value.trim());
        if (blank) return bad(blank.querySelector('input.handle'), fill(J.need_handle, { site: blank.dataset.site }));
        if (!fol.value.trim()) return bad(fol, 'Add your estimated total followers');
        location.href = mail(S.contact.email, J.subject, [J.intro, '', `Name: ${name.value.trim()}`,
          ...on.map(r => `${r.dataset.site}: ${at(r.querySelector('input.handle').value.trim())}`),
          `${J.followers}: ${fol.value.trim()}`, ''].join('\n')); } },
      el('label', { class: 'j-field' },
        el('input', { type: 'text', name: 'name', placeholder: J.name, 'aria-label': J.name, autocomplete: 'name', required: true })),
      el('fieldset', {}, el('legend', {}, J.socials_legend),
        J.socials.map(s => el('div', { class: 'j-social', 'data-site': s },
          el('label', { class: 'j-tick' }, el('input', { type: 'checkbox', value: s, onchange: e => sync(e.target.closest('.j-social')) }), s),
          el('label', { class: 'j-handle' }, el('span', { class: 'at', 'aria-hidden': 'true' }, '@'),
            el('input', { type: 'text', class: 'handle', placeholder: `${s} handle`, 'aria-label': `${s} handle`, autocomplete: 'off', autocapitalize: 'off', spellcheck: 'false',
              // typing a handle ticks its box; emptying it unticks it
              oninput: e => { const r = e.target.closest('.j-social'); if (/^\s*@/.test(e.target.value)) e.target.value = e.target.value.replace(/^\s*@+/, '');   // the @ is already printed
                r.querySelector('input[type=checkbox]').checked = !!e.target.value.trim(); sync(r); } }))))),
      el('label', { class: 'j-field' },
        el('input', { type: 'text', name: 'followers', placeholder: J.followers, 'aria-label': J.followers, inputmode: 'numeric', autocomplete: 'off', required: true })),
      el('div', { class: 'j-go' },
        el('button', { class: 'script apply-title', type: 'submit' }, J.button),
        J.note ? el('p', { class: 'apply-note' }, fill(J.note, { email: S.contact.email })) : null));
  }
  const sizeText = p => inStock(p).join(', ');
  const detailText = p => [`${p.short}${p.style ? ' (' + p.style + ')' : ''}, ${money(p.price)}`, `Sizes: ${sizeText(p)}`,
    p.colours.length ? `Colors: ${p.colours.join(', ')}` : '', p.fabric ? `Fabric: ${fabric(p)}` : '',
    `modenaire.com: ${p.url}`, p.nordstrom ? `Also available on Nordstrom.com: ${p.nordstrom}` : '']
    .filter(Boolean).join('\n');
  const csv = () => [['Piece', 'Style', 'Price', 'Sizes', 'Colors', 'Fabric', 'Care', 'modenaire.com', 'Nordstrom.com', 'Lead image']]
    .concat(D.products.map(p => [p.short, p.style, p.price, sizeText(p), p.colours.join(' / '), fabric(p), p.care, p.url, p.nordstrom, leadImg(p).src]))
    .map(r => r.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(',')).join('\n');

  // a muted, looping background video: plays only while on screen, and never for readers who ask for less motion
  const vids = [];
  // phones held upright get the portrait cut of the hero film
  const uprightPhone = matchMedia('(max-width: 760px) and (orientation: portrait)');
  const heroFilm = () => uprightPhone.matches && V.hero_video_mobile ? [V.hero_video_mobile, V.hero_poster_mobile] : [V.hero_video, V.hero_poster];
  // lazy: a film further down the page (the brown jacket) waits until it is about a screen away before it downloads;
  // until then (and for readers who ask for less motion) its poster photo shows
  function bgVideo(file, poster, cls, lazy) {
    const v = el('video', { class: cls || null, poster: lazy ? null : poster, playsinline: true, loop: true, muted: true, preload: lazy ? 'none' : 'metadata', 'aria-hidden': 'true', 'data-src': lazy ? file : null, 'data-poster': lazy ? poster : null },
      lazy ? null : el('source', { src: file, type: 'video/mp4' }));
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    vids.push(v); return v;
  }
  function watchVideos() {
    const still = !vids.length || reduce.matches || !('IntersectionObserver' in window);
    const coverOf = v => { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } };
    if (still) { vids.forEach(coverOf); return; }   // no films playing: the cover photos show instead
    const near = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target; if (!e.isIntersecting || !v.dataset.src) return;
      coverOf(v); v.append(el('source', { src: v.dataset.src, type: 'video/mp4' })); delete v.dataset.src; v.preload = 'auto'; v.load(); near.unobserve(v);
    }), { rootMargin: '100% 0px' });
    vids.forEach(v => { if (v.dataset.src) near.observe(v); });
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { const p = e.target.play(); if (p && p.catch) p.catch(() => {}); } else e.target.pause();
    }), { threshold: 0.05 });
    vids.forEach(v => io.observe(v));
  }

  // ---------- the ribbon illustration: a strip of fabric drawn in fine lines, twisting as it crosses the page ----------
  function ribbon({ lines = 28, amp = 260, turns = 1.2, twist = 2.3, width = 170, y0 = 500, phase = 0 } = {}) {
    const NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1600 1000'); svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('class', 'ribbon');
    for (let i = 0; i < lines; i++) {
      const k = i / (lines - 1) - 0.5; let d = '';
      for (let s = 0; s <= 96; s++) {
        const t = s / 96, x = -160 + t * 1920, a = t * Math.PI * turns + phase;
        const yc = y0 + amp * Math.sin(a), dy = amp * Math.PI * turns / 1920 * Math.cos(a), len = Math.hypot(1, dy);
        const w = width * Math.cos(t * Math.PI * twist + phase * 0.7) * (0.55 + 0.45 * Math.sin(t * Math.PI));
        d += (s ? 'L' : 'M') + (x - dy / len * k * w).toFixed(1) + ' ' + (yc + 1 / len * k * w).toFixed(1);
      }
      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d); path.setAttribute('pathLength', '1'); path.style.setProperty('--d', (i * 0.035).toFixed(3) + 's');
      svg.append(path);
    }
    return svg;
  }

  // ---------- page ----------
  function render() {
    const c = S.contact, [lo, hi] = D.price_range, N = D.products.length;
    const slot = ([h, i]) => byHandle[h] && byHandle[h].images[i] ? { p: byHandle[h], im: byHandle[h].images[i] } : null;
    const hero = pick('hero'), trio = (V.trio || []).map(slot).filter(Boolean);
    const smpCycle = (V.samples_cycle || []).map(([h, i]) => byHandle[h] && byHandle[h].images[i] ? { p: byHandle[h], im: byHandle[h].images[i] } : null).filter(Boolean);
    const st = pick('statement'), stSmall = pick('statement_small'), mood = pick('mood'), smp = pick('samples'), feat = pick('featured'), con = pick('contacts');
    const soldAt = S.sold_at.map(([n, u], k) => [k ? ', ' : '', u ? el('a', { href: u, target: '_blank', rel: 'noopener' }, n) : n]);
    const frame = (x, cls, w) => x && el('figure', { class: 'frame ' + cls }, el('img', { class: 'px', src: src(x.im, w), alt: '', loading: 'lazy' }));
    const head = (n, id, script, caps, lede) => el('div', { class: 'sec-head rv' }, el('p', { class: 'small' }, 'Chapter ' + n),
      tt('h2', script, caps, { id: 'h-' + id }), lede && el('p', { class: 'sec-lede' }, lede));

    root.replaceChildren(
      el('header', { class: 'bar', 'data-tone': 'dark' },
        el('button', { class: 'menu-btn', type: 'button', 'aria-expanded': 'false', 'aria-controls': 'pr-menu', onclick: () => toggleMenu() },
          el('span', { class: 'burger', 'aria-hidden': 'true' }), el('span', { class: 'mlabel' }, 'Menu')),
        el('a', { class: 'logo', href: '#top', 'aria-label': T.logo_aria }, el('span', { class: 'word' }, 'Modenaire'), el('span', { class: 'sub' }, T.logo_sub)),
        el('a', { class: 'hlink', href: '#contacts' }, T.bar_link)),

      el('nav', { class: 'menu dark', id: 'pr-menu', 'aria-label': 'Chapters', 'aria-hidden': 'true', inert: true },
        ribbon({ y0: 520, amp: 300, phase: 1.1, lines: 24 }),
        el('ol', {}, CHAPTERS.map(([id, name], k) => el('li', {}, el('a', { href: '#' + id, onclick: () => toggleMenu(false) },
          el('span', { class: 'small' }, 'Chapter ' + (k + 1)), el('span', { class: 'caps' }, name))))),
        el('a', { class: 'menu-home', href: 'https://modenaire.com/' }, el('span', {}, 'Visit modenaire.com'), icon('right')),
        el('div', { class: 'menu-foot' }, el('span', {}, c.name), el('a', { href: `mailto:${c.email}` }, c.email), el('span', {}, c.phone))),

      // 1. opening
      el('section', { class: 'hero dark', id: 'top', 'data-tone': 'dark', 'aria-label': T.hero_aria },
        V.hero_video ? bgVideo(...heroFilm(), 'hero-img wide')
          : V.hero_src ? el('img', { class: 'hero-img wide', src: V.hero_src, alt: '', fetchpriority: 'high' })
          : hero && el('img', { class: 'hero-img', src: src(hero.im, 1800), srcset: `${src(hero.im, 1100)} 1100w, ${src(hero.im, 1800)} 1800w`, sizes: '100vw', alt: '', fetchpriority: 'high' }),
        el('div', { class: 'veil' }),
        el('div', { class: 'hero-copy' },
          el('p', { class: 'small hero-kicker' }, T.hero_kicker),   // says what the page is from the first screen
          tt('h1', 'Designed in California,', 'in small collections'),
          el('a', { class: 'explore', href: '#intro' }, el('span', {}, 'Explore more'), icon('down'))),
        !V.hero_src && !V.hero_video && hero && el('p', { class: 'credit' }, `${hero.p.short}, ${money(hero.p.price)}`)),

      // 2. three photos that zoom as you scroll
      el('section', { class: 'intro light', id: 'intro', 'data-tone': 'light', 'aria-labelledby': 'h-intro' },
        el('div', { class: 'intro-head rv' }, el('p', { class: 'small' }, 'Our fall collection'),
          el('h2', { class: 'caps', id: 'h-intro' }, 'Sharp Weather')),
        el('div', { class: 'trio' }, trio.map((t, k) => el('figure', { class: 'trio-' + ['l', 'm', 'r'][k] },
          el('img', { src: src(t.im, k === 1 ? 1400 : 900), alt: `${t.p.short}, worn`, loading: 'lazy' }))))),

      // 3. what the page is for
      el('section', { class: 'statement light swipe', 'data-tone': 'light', 'aria-labelledby': 'h-statement' },
        el('h2', { class: 'caps', id: 'h-statement' }, T.statement.map((t, k) =>
          el('span', { class: 'ln', style: `--i:${k}` }, el('span', {}, t)))),
        // a line ending in '...' shows its three dots one at a time, after the line itself has appeared
        T.statement_script ? el('p', { class: 'script over' }, (m => m ? [m[1], el('span', { class: 'dots' }, [...Array(m[2] === '…' ? 3 : m[2].length)].map((_, k) => el('span', { class: 'dot', style: `--k:${k}` }, '.')))] : T.statement_script)(T.statement_script.match(/^(.*?)(…|\.{2,})$/))) : null,
        frame(st, 'st-big', 1200),
        T.statement_note ? (n => { const pct = parseFloat(S.earn.rate) / 100, x = { lo: money(lo), hi: money(hi), top: '$' + Math.floor(hi * pct) };
          return el('div', { class: 'st-earn' }, el('p', { class: 'small' }, n.label), el('p', { class: 'st-big-num' }, fill(n.big, x)),
            el('p', { class: 'st-line' }, fill(n.line, x)), el('p', { class: 'st-text' }, fill(n.text, x)),
            n.link ? el('a', { class: 'script st-apply', href: n.link.href }, n.link.label) : null); })(T.statement_note)
          : frame(stSmall, 'st-small', 900)),

      // 4. the edit (chapter 1): curved WebGL gallery, straight after the statement
      el('section', { class: 'worlds dark', id: 'edit', 'data-tone': 'dark', 'aria-labelledby': 'h-edit' },
        el('div', { class: 'w-pin' },
          ribbon({ y0: 560, amp: 240, phase: 0.2 }),
          el('canvas', { class: 'w-gl', 'aria-hidden': 'true' }),
          el('div', { class: 'w-head' },
            el('p', { class: 'small' }, chap('edit')),
            tt('h2', 'The fall', 'edition', { id: 'h-edit' })),
          el('div', { class: 'w-side' },
            el('div', { class: 'edits w-edits', role: 'group', 'aria-label': 'Edits' },
              D.edits.map(e => el('button', { type: 'button', 'data-edit': e.slug, 'aria-pressed': String(state.edit === e.slug),
                onclick: () => setEdit(state.edit === e.slug ? 'all' : e.slug) }, e.name)))),
          el('div', { class: 'w-cap', 'aria-live': 'polite' },
            el('p', { class: 'caps w-name' }), el('p', { class: 'w-meta' }),
            el('div', { class: 'w-acts' },
              el('button', { class: 'round', type: 'button', 'aria-label': 'Previous piece', onclick: () => G.step(-1) }, icon('left')),
              el('button', { class: 'link', type: 'button', onclick: () => G.openActive() }, 'View details'),
              el('button', { class: 'round', type: 'button', 'aria-label': 'Next piece', onclick: () => G.step(1) }, icon('right')))),
          el('button', { class: 'w-arrow prev', type: 'button', 'aria-label': 'Previous piece', onclick: () => G.step(-1) }, icon('left')),
          el('button', { class: 'w-arrow next', type: 'button', 'aria-label': 'Next piece', onclick: () => G.step(1) }, icon('right')),
          el('div', { class: 'w-count', 'aria-hidden': 'true' }, el('span', { class: 'ring-slot' }), el('span', {})),
          el('div', { class: 'w-fallback' }))),

      // 5. a framed film that grows to fill the screen, then on to the press kit
      el('section', { class: 'mood dark', 'data-tone': 'dark', 'aria-label': 'Sharp Weather' },
        el('div', { class: 'm-pin' },
          V.mood_video ? el('div', { class: 'm-frame color' }, bgVideo(V.mood_video, V.mood_poster, null, true))
            : mood && el('div', { class: 'm-frame' }, el('img', { src: src(mood.im, 1800), alt: '', loading: 'lazy' })),
          el('p', { class: 'small m-before' }, 'Keep scrolling'),
          el('div', { class: 'mood-copy' },
            el('p', { class: 'small mood-line' }, T.mood_line[0], el('br'), T.mood_line[1]),
            el('a', { class: 'script mood-link', href: T.mood_link.href }, T.mood_link.label)))),

      // 6. featured in (hidden for now): proof first, then the stores that carry us
      !S.featured_on ? '' : el('section', { class: 'featured light', id: 'featured', 'data-tone': 'light', 'aria-labelledby': 'h-featured' },
        el('div', { class: 'f-grid' },
          el('div', {},
            el('h2', { class: 'small', id: 'h-featured' }, `${chap('featured')}  ·  Featured in`),
            el('span', { class: 'qmark', 'aria-hidden': 'true' }, '“'),
            S.quote && el('blockquote', { class: 'caps rv' }, S.quote.text),
            S.quote && el('p', { class: 'small who' }, S.quote.url ? el('a', { href: S.quote.url, target: '_blank', rel: 'noopener' }, S.quote.outlet) : S.quote.outlet, `  ·  ${S.quote.date}`),
            el('ul', { class: 'clips' }, D.coverage.map(k => el('li', {},
              el('span', { class: 'soft' }, new Date(k.date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', year: 'numeric' })),
              el('span', { class: 'outlet' }, k.outlet),
              el('span', {}, el('a', { href: k.url, target: '_blank', rel: 'noopener' }, k.headline), k.piece ? `  (${k.piece})` : ''))))),
          feat && el('figure', { class: 'f-img' }, el('div', { class: 'frame' }, el('img', { class: 'px', src: src(feat.im, 1100), alt: `${feat.p.short}, worn`, loading: 'lazy' })),
            el('figcaption', { class: 'small' }, `${feat.p.short}, ${money(feat.p.price)}`)))),

      // 7. stores that carry Modenaire, each logo linking to our shop there
      (S.stockists || []).length ? el('section', { class: 'stockists light', 'data-tone': 'light', 'aria-labelledby': 'h-stockists' },
        el('h2', { class: 'small', id: 'h-stockists' }, 'Also available at'),
        // on phones the logos roll past in one row: the list is drawn twice so the loop has no gap (the copy is hidden
        // from screen readers and keyboards, and from everyone on wider screens)
        el('div', { class: 'st-track' }, [0, 1].map(copy => el('ul', copy ? { class: 'st-copy', 'aria-hidden': 'true' } : {}, S.stockists.map(s => {
          const logo = el('img', { src: s.logo, alt: copy ? '' : s.name, style: `--h:${s.h}px`, loading: 'lazy' });
          return el('li', {}, s.url ? el('a', { href: s.url, target: '_blank', rel: 'noopener', title: `Modenaire at ${s.name}`, tabindex: copy ? '-1' : null }, logo) : el('span', { class: 'nolink' }, logo));
        })))),
        S.draft_banner && S.stockists_note && el('p', { class: 'st-note' }, S.stockists_note)) : '',   // replaceChildren would print null

      // 8. press kit: every piece at a glance, then the downloads
      hidden.has('downloads') ? '' : el('section', { class: 'downloads light', id: 'downloads', 'data-tone': 'light', 'aria-labelledby': 'h-downloads' },
        el('div', { class: 'sec-head rv' }, el('p', { class: 'small' }, chap('downloads')),
          el('h2', { class: 'script one-line', id: 'h-downloads' }, el('span', { class: 'red' }, T.kit_title))),
        el('div', { class: 'plist rv' }, el('p', { class: 'small' }, 'The pieces at a glance'),
          el('ul', {}, D.products.map((p, k) => el('li', {},
            el('button', { class: 'pl-img', type: 'button', 'aria-label': `Open the ${p.short}`, onclick: () => openPiece(p) }, el('img', { src: src(flatImg(p), 160), alt: '', loading: 'lazy' })),
            el('div', { class: 'pl-name' }, el('p', { class: 'small' }, 'No. ' + pad(k + 1)), el('h3', { class: 'caps' }, el('button', { class: 'pl-title', type: 'button', onclick: () => openPiece(p) }, p.short))),
            el('span', { class: 'pl-price' }, money(p.price)),
            el('span', { class: 'pl-sizes' }, sizesNode(p)),
            el('div', { class: 'pl-acts' },
              el('button', { class: 'link', type: 'button', onclick: () => openPiece(p) }, 'Details')))))),
        el('p', { class: 'small dl-label' }, 'Downloads'),
        el('ol', { class: 'dl-rows' },
          el('li', {}, el('a', { class: 'dl-row', href: S.linesheet_url || '#', target: '_blank', rel: 'noopener', onclick: e => { if (!S.linesheet_url) { e.preventDefault(); print(); } } },
            el('span', { class: 'caps' }, T.dl_linesheet), el('span', { class: 'round' }, icon('right')))),
          el('li', {}, el('button', { class: 'dl-row', type: 'button', onclick: () => save(new Blob([csv()], { type: 'text/csv' }), T.csv_file) },
            el('span', { class: 'caps' }, 'Product data'), el('span', { class: 'round' }, icon('right')))),
          el('li', {}, el('a', { class: 'dl-row', href: S.factsheet_url || '#', target: '_blank', rel: 'noopener' },
            el('span', { class: 'caps' }, T.dl_factsheet), el('span', { class: 'round' }, icon('right')))))),


      // 9. about: the section holds, and each scroll plays one slide: title, then the text, then the facts (aboutSlide())
      el('section', { class: 'about light', id: 'about', 'data-tone': 'light', 'aria-labelledby': 'h-about' },
        el('div', { class: 'a-pin' }, el('div', { class: 'a-stage' }, el('div', { class: 'a-track' },
          el('div', { class: 'a-panel a-p1' },
            el('div', { class: 'a-in rv' },
              el('p', { class: 'small' }, chap('about')),
              tt('h2', 'About', 'Modenaire', { id: 'h-about' }))),
          el('div', { class: 'a-panel a-p2' },
            el('div', { class: 'a-in' },
              el('p', { class: 'a-lede', id: 'pr-desc' }, `${S.brand_line} Based in ${S.based}, and available at ${listJoin(S.sold_at.map(x => x[0]))}.`))),
          el('div', { class: 'a-panel a-p3' },
            el('div', { class: 'a-in' },
              el('dl', { class: 'kv' },
                el('dt', {}, 'Based in'), el('dd', {}, S.based),
                el('dt', {}, 'Prices'), el('dd', {}, `${money(lo)} to ${money(hi)} for the pieces shown`),
                el('dt', {}, 'Sizes'), el('dd', {}, D.size_range.filter(x => !/one size/i.test(x)).join(', ')),
                el('dt', {}, 'Available at'), el('dd', {}, soldAt),
                el('dt', {}, T.about_contact), el('dd', {}, c.name, ', ', c.email)))))))),

      // 10. samples
      el('section', { class: 'samples dark', id: 'samples', 'data-tone': 'dark', 'aria-labelledby': 'h-samples' },
        ribbon({ y0: 380, amp: 220, phase: 2.2, twist: 1.8, lines: 24 }),
        // the heading and photo hold still for a short stretch of scrolling while the heading grows (frame() sets --sg)
        el('div', { class: 's-pin' }, el('div', { class: 's-stage' },
          el('p', { class: 'small rv' }, chap('samples')),
          el('h2', { class: 'ghost caps lift', id: 'h-samples' }, T.samples_title.map((t, k) => el('span', { class: 'gl', style: `--i:${k}` }, t))),
          smpCycle.length > 1 ? el('figure', { class: 'frame s-img cycle' }, smpCycle.map((x, k) => el('img', { class: 'px' + (k ? '' : ' on'), src: src(x.im, 1200), alt: '', loading: k ? 'lazy' : null })))   // the first shows on arrival, so it loads with the page
            : frame(smp, 's-img', 1200))),
        el('div', { class: 's-cols' }, T.samples_cols.map(col => el('div', { class: 'rv' }, el('h3', { class: 'small' }, col.title),
          el('p', {}, fill(col.text)),
          col.link && el('a', { class: 'link', href: mail(c.email, fill(col.link.subject), fill(col.link.body)) }, col.link.label))))),

      // 10b. testimonials (creator page only): not a chapter, so the menu numbers stay as they are
      !T.testimonials ? '' : el('section', { class: 'voices light', id: 'voices', 'data-tone': 'light', 'aria-labelledby': 'h-voices' },
        el('div', { class: 'v-head rv' }, el('p', { class: 'small' }, T.testimonials.label),
          tt('h2', T.testimonials.title[0], T.testimonials.title[1], { id: 'h-voices' })),
        el('ul', { class: 'v-list' }, T.testimonials.items.map((t, k) => el('li', { class: 'v-card rv', style: `--i:${k}` },
          el('span', { class: 'v-mark', 'aria-hidden': 'true' }, '\u201C'),
          el('blockquote', {}, el('p', {}, t.quote)),
          el('p', { class: 'v-who' }, t.name, t.handle ? [el('br'), t.handle] : null))))),

      // 11. contacts
      el('section', { class: 'contact', id: 'contacts', 'data-tone': 'light', 'aria-labelledby': 'h-contacts' },
        // the page's line drawing with the colours flipped (burgundy on light brown), sweeping in from both sides
        ribbon({ y0: 380, amp: 380, turns: 1.35, phase: 0.35, twist: 1.9, width: 250, lines: 34 }),
        (r => (r.classList.add('flip'), r))(ribbon({ y0: 620, amp: 360, turns: 1.25, phase: 1.9, twist: 2.2, width: 230, lines: 30 })),
        el('div', { class: 'c-card light rv' },
          el('div', { class: 'word' }, 'Modenaire'),
          el('p', { class: 'small' }, chap('contacts')),
          tt('h2', T.contacts_title[0], T.contacts_title[1], { id: 'h-contacts' }),
          // one person, one address, one number: three columns
          T.contact_row ? el('div', { class: 'c-list' },
            el('p', {}, c.name),
            el('p', {}, el('a', { href: `mailto:${c.email}` }, c.email)),
            c.phone && el('p', {}, el('a', { href: `tel:${c.phone.replace(/[^0-9+]/g, '')}` }, c.phone))) : null,
          // the creator page swaps the form for its join form, or for one call to action (a link once its address is set)
          T.join_form ? joinForm(T.join_form) :
          T.apply ? el('div', { class: 'apply-now' },
            T.apply.href ? el('a', { class: 'script apply-title', href: T.apply.href, target: '_blank', rel: 'noopener' }, T.apply.title) : el('p', { class: 'script apply-title' }, T.apply.title),
            T.apply.note ? el('p', { class: 'apply-note' }, T.apply.note) : null) :
          el('form', { class: 'alerts', onsubmit: e => { e.preventDefault(); const f = e.target;
              const t = [...f.querySelectorAll('input[type=checkbox]:checked')].map(x => x.value).concat(f.querySelector('input[name=other]').value.trim()).filter(Boolean).join(', ');
              const hs = [...f.querySelectorAll('input.handle')], got = hs.filter(x => x.value.trim());
              if (hs.length && !got.length) { hs[0].setCustomValidity('Add your Instagram or TikTok handle'); hs[0].reportValidity(); return; }
              location.href = mail(c.email, T.form_subject, `Email: ${f.querySelector('input[type=email]').value}\n` + got.map(x => `${x.dataset.label}: @${x.value.trim().replace(/^@+/, '')}\n`).join('') + `${T.form_legend} ${t}`); } },
            el('p', { class: 'small' }, T.form_title),
            // the creator page also asks for their handles (at least one); the press page doesn't
            T.form_handles.length ? el('div', { class: 'handles' }, T.form_handles.map(h =>
              el('label', { class: 'handle-box' }, el('span', { class: 'at', 'aria-hidden': 'true' }, '@'),
                el('input', { type: 'text', class: 'handle', 'data-label': h, placeholder: `${h} handle`, 'aria-label': `${h} handle`,
                  autocomplete: 'off', autocapitalize: 'off', spellcheck: 'false', oninput: e => e.target.form.querySelectorAll('input.handle').forEach(x => x.setCustomValidity('')) })))) : null,
            el('div', { class: 'row' },
              el('input', { type: 'email', required: true, placeholder: 'Email', 'aria-label': 'Email' }),
              el('button', { class: 'link', type: 'submit' }, T.form_button)),
            el('fieldset', {}, el('legend', {}, T.form_legend),
              T.form_topics.map(t => el('label', {}, el('input', { type: 'checkbox', value: t }), t)),
              el('label', { class: 'other' }, 'Other', el('input', { type: 'text', name: 'other', 'aria-label': T.form_other_aria })))))),

      // footer
      el('footer', { class: 'foot dark', 'data-tone': 'dark' },
        ribbon({ y0: 420, amp: 200, phase: 3.4, twist: 2, lines: 22 }),
        el('p', { class: 'foot-big caps' }, T.footer.flatMap((t, k) => k ? [el('br'), t] : [t]))),

      S.draft_banner && el('div', { class: 'draft', role: 'note' }, el('span', {}, S.draft_banner),
        el('button', { class: 'link', type: 'button', onclick: e => e.target.closest('.draft').remove() }, 'Hide')),

      el('div', { class: 'linesheet', 'aria-hidden': 'true' },
        el('div', { class: 'word' }, 'Modenaire'), el('h1', {}, T.linesheet_title),
        el('p', {}, `${S.brand_line} ${T.linesheet_contact}: ${c.name}, ${c.email}, ${c.phone}. Updated ${D.built}.`),
        el('table', {}, el('thead', {}, el('tr', {}, ['', 'Piece', 'Price', 'Sizes', 'Colors', 'Fabric', 'Links'].map(h => el('th', {}, h)))),
          el('tbody', {}, D.products.map(p => el('tr', {},
            el('td', {}, el('img', { src: src(flatImg(p), 240), alt: '' })),
            el('td', {}, el('strong', {}, p.short), el('br'), p.style), el('td', {}, money(p.price)), el('td', {}, sizeText(p)),
            el('td', {}, p.colours.join(', ')), el('td', {}, fabric(p)),
            el('td', {}, p.url, p.nordstrom ? [el('br'), p.nordstrom] : '')))))));
    ring();
  }

  // the progress ring beside the gallery (built as real SVG, which el() cannot do)
  function ring() {
    const NS = 'http://www.w3.org/2000/svg', box = document.createElementNS(NS, 'svg');
    box.setAttribute('viewBox', '0 0 84 84'); root.querySelector('.w-count .ring-slot').replaceWith(box);
    ['a', 'b'].forEach(() => { const c = document.createElementNS(NS, 'circle'); c.setAttribute('cx', '42'); c.setAttribute('cy', '42'); c.setAttribute('r', '41'); c.setAttribute('pathLength', '1'); box.append(c); });
    box.lastChild.style.opacity = '1'; box.firstChild.style.opacity = '.25';
  }

  // ---------- menu ----------
  let menuOpen = false, lastFocus = null;
  function toggleMenu(force) {
    menuOpen = typeof force === 'boolean' ? force : !menuOpen;
    root.classList.toggle('menu-open', menuOpen);
    const btn = root.querySelector('.menu-btn'), m = root.querySelector('.menu');
    btn.setAttribute('aria-expanded', String(menuOpen));
    btn.querySelector('.mlabel').textContent = menuOpen ? 'Close' : 'Menu';
    m.setAttribute('aria-hidden', String(!menuOpen)); m.inert = !menuOpen;
    document.documentElement.style.overflow = menuOpen ? 'hidden' : '';
    if (menuOpen) { lastFocus = document.activeElement; m.querySelector('.ribbon').classList.add('in'); setTimeout(() => m.querySelector('a').focus({ preventScroll: true }), 80); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    tone();
  }
  addEventListener('keydown', e => { if (e.key === 'Escape' && menuOpen) toggleMenu(false); });

  // ---------- piece details (images, facts, samples, downloads) ----------
  let dlg, cur;
  function openPiece(p, i) {
    const imgs = p.images, n = imgs.length;
    if (i == null || i < 0) i = imgs.indexOf(leadImg(p));
    i = ((i % n) + n) % n; cur = { p, i };
    if (!dlg) {
      dlg = el('dialog', { class: 'gallery', 'aria-labelledby': 'pr-gal-h' }); root.append(dlg);
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', e => {
        if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !(e.target.matches && e.target.matches('input, textarea'))) { e.preventDefault(); openPiece(cur.p, cur.i + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
    }
    const im = imgs[i], k = D.products.indexOf(p), [sc, cp] = split(p.short);
    const pairs = (p.pairs || []).map(h => byHandle[h]).filter(Boolean);
    const keep = dlg.open && dlg.contains(document.activeElement);
    dlg.replaceChildren(
      el('button', { class: 'link close', type: 'button', onclick: () => dlg.close() }, 'Close'),
      el('div', { class: 'gal' },
        el('div', { class: 'big' }, el('img', { src: src(im, 1600), alt: `${p.short}, image ${i + 1} of ${n}` })),
        el('div', { class: 'side' },
          el('p', { class: 'small' }, `No. ${pad(k + 1)}`, editNames(p) ? '  ·  ' + editNames(p) : ''),
          tt('h3', sc, cp, { id: 'pr-gal-h' }),
          el('p', { class: 'price' }, money(p.price), p.compare_at > p.price && el('s', {}, money(p.compare_at)), el('span', { class: 'sizes' }, sizesNode(p))),
          p.why && el('p', { class: 'why' }, p.why),
          el('dl', { class: 'facts' },
            p.colours.length ? [el('dt', {}, 'Colors'), el('dd', {}, p.colours.join(', '))] : null,
            p.fabric && [el('dt', {}, 'Fabric'), el('dd', {}, fabric(p))],
            p.care && [el('dt', {}, 'Care'), el('dd', {}, p.care)],
            p.model && [el('dt', {}, 'Model'), el('dd', {}, p.model + ' (height, size worn)')],
            [el('dt', {}, 'Made in'), el('dd', {}, S.origin)]),
          el('div', { class: 'acts' },
            T.piece_cta ? el('a', { class: 'link', href: sampleMail(p) }, T.piece_cta.label) : null,   // the creator page has none (16 Oct 2026)
            el('button', { class: 'link', type: 'button', onclick: () => zipOne(p) }, `Download all ${n}`),
            el('button', { class: 'link', type: 'button', onclick: () => downloadImage(im) }, 'This image'),
            el('button', { class: 'link', type: 'button', onclick: () => copy(detailText(p), 'Details') }, 'Copy details'),
            el('a', { class: 'link', href: p.url, target: '_blank', rel: 'noopener' }, 'modenaire.com'),
            p.nordstrom ? el('a', { class: 'link', href: p.nordstrom, target: '_blank', rel: 'noopener' }, 'Nordstrom.com') : null),
          el('div', { class: 'grid' }, imgs.map((x, j) => el('button', { type: 'button', 'aria-current': String(i === j), 'aria-label': `Image ${j + 1}`, onclick: () => openPiece(p, j) }, el('img', { src: src(x, 240), alt: '' })))),
          el('div', { class: 'steps' },
            el('button', { class: 'round', type: 'button', 'aria-label': 'Previous image', onclick: () => openPiece(p, i - 1) }, icon('left')),
            el('span', { class: 'small' }, `Image ${i + 1} of ${n}`),
            el('button', { class: 'round', type: 'button', 'aria-label': 'Next image', onclick: () => openPiece(p, i + 1) }, icon('right'))),
          pairs.length > 0 && el('div', { class: 'pairs' }, el('p', { class: 'small' }, 'Style it with'),
            el('ul', {}, pairs.map(q => el('li', {}, el('button', { type: 'button', onclick: () => openPiece(q) }, el('img', { src: src(leadImg(q), 200), alt: '' }), q.short))))),
          S.draft_banner && p.note && el('p', { class: 'note' }, 'Draft note: ' + p.note))));
    if (!dlg.open) dlg.showModal();
    if (keep) (dlg.querySelector('.grid [aria-current="true"]') || dlg.querySelector('.close')).focus();
  }

  // ---------- the edit: a curved gallery drawn with WebGL ----------
  // the pieces sit on a loop: the last ones already show to the left of the first, and after the last comes the first again
  const mod = (a, n) => ((a % n) + n) % n;
  const G = { items: [], cur: 0, target: 0, vel: 0, active: -1, visible: false, gl: false, meshes: [], shift: 0, lap: 0,
    step(d) {
      const n = G.items.length; if (!n) return;
      if (!G.gl) return goPiece(G.items[mod(G.active + d, n)].handle);
      G.rest += d; G.target = G.rest; settleGallery();
    },
    openActive() { const p = G.items[mod(G.active, G.items.length || 1)]; if (p) openPiece(p); } };
  const VS = `
    uniform float uBend; uniform float uShift;
    varying vec2 vUv; varying float vX;
    void main() {
      vUv = uv;
      vec4 w = modelMatrix * vec4(position, 1.0);
      w.z += w.x * w.x * uBend;
      w.y += w.x * uShift;
      vX = w.x;
      gl_Position = projectionMatrix * viewMatrix * w;
    }`;
  const FS = `
    uniform sampler2D uTex; uniform vec2 uScale; uniform float uReady; uniform float uFar;
    varying vec2 vUv; varying float vX;
    void main() {
      vec2 uv = vec2((vUv.x - 0.5) * uScale.x + 0.5, (vUv.y - 1.0) * uScale.y + 1.0);
      vec3 c = texture2D(uTex, uv).rgb;
      float near = 1.0 - smoothstep(0.0, uFar, abs(vX));
      vec3 bg = vec3(0.227, 0.173, 0.176);
      gl_FragColor = vec4(mix(bg, c * (0.42 + 0.58 * near), uReady), 1.0);
    }`;
  function galleryItems() { return D.products.filter(p => state.edit === 'all' || p.edits.includes(state.edit)); }
  function setupGallery() {
    const sec = root.querySelector('.worlds'), cv = sec.querySelector('.w-gl');
    G.sec = sec; G.pin = sec.querySelector('.w-pin'); G.items = galleryItems();
    let ok = false;
    if (window.THREE && !reduce.matches) { try { const t = document.createElement('canvas'); ok = !!(t.getContext('webgl') || t.getContext('experimental-webgl')); } catch (e) {} }
    G.gl = ok;
    if (!ok) { sec.classList.add('no-gl'); fallbackGallery(); caption(); return; }
    const T = window.THREE;
    G.renderer = new T.WebGLRenderer({ canvas: cv, antialias: true, alpha: true });
    G.renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2)); G.renderer.setClearColor(0x000000, 0);
    G.scene = new T.Scene(); G.camera = new T.PerspectiveCamera(35, 1, 0.1, 100); G.camera.position.z = 10;
    G.geo = new T.PlaneGeometry(1, 1, 40, 1);
    G.U = { bend: { value: 0.06 }, shift: { value: 0 }, far: { value: 6 } };
    G.loader = new T.TextureLoader(); G.loader.setCrossOrigin('anonymous');
    buildMeshes(); layoutGallery();
    if (document.fonts) document.fonts.ready.then(layoutGallery);   // the title's height depends on the web fonts
    new IntersectionObserver(es => { G.visible = es[0].isIntersecting; if (!G.visible) G.lap = null; if (G.visible && !G.raf) G.raf = requestAnimationFrame(tick); }, { rootMargin: '100px 0px' }).observe(sec);
    G.wLast = 0; G.wStep = 0; G.wAcc = 0; G.wUsed = false;
    G.pin.addEventListener('wheel', onWheel, { passive: false });
    // swipe or drag sideways on the photos to browse; up-and-down swipes stay with the page (touch-action: pan-y)
    const per = () => G.SP / G.viewW * cv.clientWidth;   // screen pixels from one photo to the next
    cv.addEventListener('pointerdown', e => { if (!e.button) G.drag = { id: e.pointerId, x: e.clientX, from: G.target, moved: false, lx: e.clientX, lt: performance.now(), v: 0 }; });
    cv.addEventListener('pointermove', e => {
      const d = G.drag; if (!d || e.pointerId !== d.id) return;
      const dx = e.clientX - d.x;
      if (!d.moved && Math.abs(dx) > 8) { d.moved = true; try { cv.setPointerCapture(e.pointerId); } catch (_) {} }
      if (!d.moved) return;
      G.target = d.from - dx / per();
      const now = performance.now(); d.v = (e.clientX - d.lx) / Math.max(1, now - d.lt); d.lx = e.clientX; d.lt = now;
    });
    const endDrag = e => {
      const d = G.drag; if (!d || e.pointerId !== d.id) return;
      if (d.moved) { G.rest = Math.round(G.target - clamp(d.v * 160 / per(), -3, 3)); G.target = G.rest; G.dragEnd = performance.now(); }
      G.drag = null;
    };
    cv.addEventListener('pointerup', endDrag); cv.addEventListener('pointercancel', endDrag);
    cv.addEventListener('click', e => {
      if (performance.now() - (G.dragEnd || 0) < 350) return;   // the end of a drag is not a tap
      const r = cv.getBoundingClientRect(), x = ((e.clientX - r.left) / r.width - 0.5) * G.viewW;
      let best = -1, bd = Infinity;
      G.meshes.forEach((m, j) => { const d = Math.abs(m.position.x - x); if (d < bd) { bd = d; best = j; } });
      if (best >= 0 && bd < G.PW * 0.6) openPiece(G.items[best % G.items.length]);
    });
  }
  function buildMeshes() {
    const T = window.THREE;
    const old = new Set();
    G.meshes.forEach(m => { G.scene.remove(m); if (m.material.uniforms.uTex.value) old.add(m.material.uniforms.uTex.value); m.material.dispose(); });
    old.forEach(t => t.dispose());
    // a short edit (three pieces of jewelry) is repeated round the loop so both sides are always filled
    const n = G.items.length, reps = n ? Math.ceil(7 / n) : 0;
    const per = G.items.map(p => {
      const ms = Array.from({ length: reps }, () => {
        const u = { uTex: { value: null }, uScale: { value: new T.Vector2(1, 1) }, uReady: { value: 0 }, uBend: G.U.bend, uShift: G.U.shift, uFar: G.U.far };
        const m = new T.Mesh(G.geo, new T.ShaderMaterial({ vertexShader: VS, fragmentShader: FS, uniforms: u }));
        m.userData.want = 0; G.scene.add(m); return m;
      });
      G.loader.load(src(leadImg(p), 900), tex => {
        tex.minFilter = T.LinearFilter; tex.generateMipmaps = false;
        const ia = tex.image.width / tex.image.height, pa = 0.75;
        ms.forEach(m => { const u = m.material.uniforms; u.uScale.value.set(ia > pa ? pa / ia : 1, ia > pa ? 1 : ia / pa); u.uTex.value = tex; m.userData.want = 1; });
      });
      return ms;
    });
    G.meshes = [];
    for (let r = 0; r < reps; r++) per.forEach(ms => G.meshes.push(ms[r]));   // slot j shows piece j % n
    G.cur = G.target = 0; G.active = -1; G.rest = 0; G.lap = 0;
  }
  function layoutGallery() {
    if (!G.gl) return;
    const w = G.pin.clientWidth, h = G.pin.clientHeight, land = w > h && h < 560, phone = w < 761 && !land;   // a phone held sideways gets the wide layout
    G.renderer.setSize(w, h, false); G.camera.aspect = w / h; G.camera.updateProjectionMatrix();
    const viewH = 2 * G.camera.position.z * Math.tan(Math.PI / 180 * G.camera.fov / 2); G.viewW = viewH * G.camera.aspect;
    G.PH = viewH * (phone ? 0.44 : 0.48); G.PW = G.PH * 0.75; G.SP = G.PW * (phone ? 1.14 : 1.24);
    G.meshes.forEach(m => { m.scale.set(G.PW, G.PH, 1); m.position.y = -viewH * (phone ? 0.02 : 0.05); });
    G.k = (phone ? 0.5 : 2.1) / Math.pow(G.viewW / 2, 2); G.U.far.value = G.viewW * (phone ? 0.95 : 0.55);   // phones: a gentler curve, so the peeking pieces stay clear
    // the gallery is one screen tall everywhere: the page scrolls past it, and the photos browse with the wheel over
    // them, a sideways swipe or drag, or the arrows (on phones the page used to scroll through all 25 first)
    G.free = true;
    G.sec.classList.toggle('free', G.free);
    let mid;
    const side = G.sec.querySelector('.w-side');
    side.style.top = '';
    {
      // the filters go just under the title (on a phone held sideways they stay bottom left), and the photo is sized to
      // the room between them and the caption, measured with the longest name, so no screen size overlaps
      const pt = G.pin.getBoundingClientRect().top, hb = G.sec.querySelector('.w-head h2').getBoundingClientRect().bottom - pt, gap = phone ? 14 : 24;
      if (!land) side.style.top = Math.round(hb + (phone ? 10 : 18)) + 'px';
      const nm = G.sec.querySelector('.w-name'), mt = G.sec.querySelector('.w-meta'), keep = [nm.textContent, mt.textContent];
      nm.textContent = G.items.reduce((a, p) => p.short.length > a.length ? p.short : a, ''); mt.textContent = '$000';
      const top = (land ? hb : side.getBoundingClientRect().bottom - pt) + gap, bot = G.sec.querySelector('.w-cap').getBoundingClientRect().top - pt - gap;
      [nm.textContent, mt.textContent] = keep;
      // on phones the photo is at most 60% of the screen wide, so the pieces either side peek in at the edges
      const ph = Math.min(clamp(bot - top, h * 0.2, h * (phone ? 0.44 : 0.48)), phone ? w * 0.6 / 0.75 : Infinity);
      G.PH = viewH * ph / h; G.PW = G.PH * 0.75; G.SP = G.PW * (phone ? 1.06 : 1.24);
      mid = (top + bot) / 2 / h;
      G.meshes.forEach(m => { m.scale.set(G.PW, G.PH, 1); m.position.y = (0.5 - mid) * viewH; });
      G.pin.style.setProperty('--arrow-y', Math.round(mid * h) + 'px');   // the side arrows sit level with the photos
    }
    const half = G.PH / viewH / 2;
    G.band = [mid - half - 0.05, mid + half + 0.05];
    G.sec.style.height = h + 'px';
  }
  function onWheel(e) {
    if (!G.gl || !G.free || !G.items.length) return;
    const r = G.pin.getBoundingClientRect(), y = (e.clientY - r.top) / r.height, top = r.top - topPx();
    if (y < G.band[0] || y > G.band[1] || Math.abs(top) > r.height * 0.35) return;   // not over the photos: the page scrolls on
    const side = Math.abs(e.deltaX) > Math.abs(e.deltaY), d = side ? e.deltaX : e.deltaY; if (!d) return;
    const now = performance.now(), n = G.items.length, dir = Math.sign(d);
    if (now - G.wLast > 180) { G.wAcc = 0; G.wUsed = false; }   // a new swipe
    G.wLast = now;
    // a lap starts when the gallery comes into view, judged by the way you are scrolling (not by where the page sits,
    // which a fast scroll overshoots): scrolling down starts at the first piece, scrolling up starts at the end to go
    // round backwards. It is cleared when the gallery leaves the screen, so a finished lap can't catch the page again.
    if (G.lap == null) G.lap = dir > 0 ? 0 : n;
    // sideways swipes go round for ever; scrolling up or down goes round once (ending back on the first piece), then a
    // new swipe carries on up or down the page, so the photos never trap the page
    const atEnd = n < 2 || (!side && (dir > 0 ? G.lap >= n : G.lap <= 0));
    if (atEnd && !G.wUsed) return;
    e.preventDefault();
    if (Math.abs(top) > 2) scrollTo({ top: scrollY + top, behavior: 'smooth' });   // settle the gallery into place
    if (atEnd) return;   // the tail of the swipe that reached the end is absorbed, so it doesn't fling the page
    G.wAcc += d;
    if ((!G.wUsed || now - G.wStep > 650) && Math.abs(G.wAcc) >= 24) {
      G.wUsed = true; G.wStep = now; G.wAcc = 0; G.rest += dir; G.target = G.rest; if (!side) G.lap += dir;
    }
  }
  function tick() {
    if (!G.visible) { G.raf = 0; return; }
    const n = G.items.length;
    const prev = G.cur; G.cur += (G.target - G.cur) * (G.drag ? 0.3 : 0.055);   // follows a finger closely, eases otherwise if (Math.abs(G.target - G.cur) < 0.0005) G.cur = G.target;
    G.vel += ((G.cur - prev) - G.vel) * 0.2;
    G.U.bend.value = G.k * (1 + Math.min(Math.abs(G.vel) * 12, 1.1));
    G.U.shift.value = clamp(G.vel * 0.35, -0.06, 0.06);
    const N = G.meshes.length;   // each photo sits at its nearest place round the loop, so there are always some either side
    G.meshes.forEach((m, j) => { m.position.x = (mod(j - G.cur + N / 2, N) - N / 2) * G.SP; const u = m.material.uniforms.uReady; u.value += (m.userData.want - u.value) * 0.06; });
    const a = n ? mod(Math.round(G.cur), n) : 0; if (a !== G.active) { G.active = a; caption(); }
    const c = root.querySelector('.w-count circle:last-child'); if (c) c.style.strokeDashoffset = String(1 - (n > 1 ? clamp((mod(G.cur + 0.5, n) + 0.5) / n, 0, 1) : 1));
    G.renderer.render(G.scene, G.camera);
    G.raf = requestAnimationFrame(tick);
  }
  function caption() {
    const p = G.items[mod(Math.max(0, G.active), G.items.length || 1)]; if (!p) return;
    root.querySelector('.w-name').textContent = p.short;
    root.querySelector('.w-meta').textContent = money(p.price);
    root.querySelector('.w-count span').textContent = `${Math.max(1, G.active + 1)} / ${G.items.length}`;
  }
  function fallbackGallery() {
    root.querySelector('.w-fallback').replaceChildren(...G.items.map(p => el('article', { class: 'w-card', id: 'card-' + p.handle },
      el('button', { type: 'button', 'aria-label': `Open the ${p.short}`, onclick: () => openPiece(p) }, el('img', { src: src(leadImg(p), 700), alt: `${p.short}, worn`, loading: 'lazy' })),
      el('h3', { class: 'caps' }, p.short), el('p', {}, money(p.price), '  ·  ', sizesNode(p)))));
  }
  function setEdit(s) {
    state.edit = s;
    root.querySelectorAll('.edits button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.edit === s)));
    history.replaceState(null, '', s === 'all' ? '#edit' : '#edit-' + s);
    G.items = galleryItems();
    if (G.gl) { buildMeshes(); layoutGallery(); } else fallbackGallery();
    caption();
    const y = G.sec.getBoundingClientRect().top + scrollY - topPx();
    if (Math.abs(scrollY - y) > 2) scrollTo({ top: y, behavior: reduce.matches ? 'auto' : 'smooth' });
  }
  function settleGallery() {
    const y = G.sec.getBoundingClientRect().top + scrollY - topPx();
    if (Math.abs(scrollY - y) > 2) scrollTo({ top: y, behavior: reduce.matches ? 'auto' : 'smooth' });
  }
  // scroll the gallery so this piece is in front (deep links, the trio photos)
  function goPiece(handle, open) {
    let i = G.items.findIndex(p => p.handle === handle);
    if (i < 0) { setEdit('all'); i = G.items.findIndex(p => p.handle === handle); }
    if (i < 0) return;
    const behavior = reduce.matches ? 'auto' : 'smooth', n = G.items.length;
    if (G.gl) {
      G.rest = G.target = i + n * Math.round((G.cur - i) / n);   // the shorter way round
      G.lap = 0; settleGallery();
    } else {
      G.sec.scrollIntoView({ behavior }); const card = document.getElementById('card-' + handle); if (card) card.scrollIntoView({ behavior, inline: 'center', block: 'nearest' });
    }
    if (open) openPiece(G.items[i]);
  }

  // ---------- scroll effects ----------
  function tone() {
    const bar = root.querySelector('.bar'); if (!bar) return;
    if (menuOpen) { bar.dataset.tone = 'dark'; return; }
    const y = bar.getBoundingClientRect().top + bar.offsetHeight / 2;
    let t = 'dark';
    for (const s of root.querySelectorAll('section[data-tone], footer[data-tone]')) { const r = s.getBoundingClientRect(); if (r.top <= y && r.bottom > y) { t = s.dataset.tone; break; } }
    bar.dataset.tone = t;
  }
  function frame() {
    tone();
    if (reduce.matches) return;
    const vh = innerHeight;
    const trio = root.querySelector('.trio');
    if (trio) {
      // the middle photo grows by up to 30% as you scroll past; room is kept below it so it never runs into the next section
      const m = trio.querySelector('.trio-m'), ch = m.offsetHeight, grow = 0.3;
      // measure without the padding already added, or the reserve flips between on and off every frame
      const reserve = Math.round(Math.max(0, ch * (1 + grow) - (trio.offsetHeight - (trio._reserve || 0))));
      if (trio._reserve !== reserve) { trio.style.paddingBottom = reserve + 'px'; trio._reserve = reserve; }  // padding, not margin: a margin would leak out of the section and the grown photo would be clipped
      const r = trio.getBoundingClientRect(), s = 1 + grow * clamp((vh - r.top) / (vh + ch * 0.55), 0, 1);
      trio.style.setProperty('--cs', s.toFixed(4));
      trio.style.setProperty('--tx', (m.offsetWidth * (s - 1) / 2).toFixed(1) + 'px');
    }
    root.querySelectorAll('.px').forEach(img => {
      const r = img.parentElement.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
      const p = clamp((r.top + r.height / 2 - vh / 2) / vh, -1, 1);
      img.style.setProperty('--py', (-p * 5).toFixed(2) + '%');
    });
    const sp = root.querySelector('.s-pin');
    if (sp) {
      const r = sp.getBoundingClientRect(), run = sp.offsetHeight - sp.firstChild.offsetHeight;
      const q = clamp(-(r.top - topPx()) / Math.max(1, run), 0, 1);
      sp.style.setProperty('--sg', (0.55 + 0.45 * (1 - Math.pow(1 - q, 2))).toFixed(3));   // eases out as it reaches full size
      if (q > 0.4 && !sp._bumped) { sp._bumped = true; if (smpCycler) smpCycler(); }   // one photo change while they're here
      if (q === 0) sp._bumped = false;
    }
    aboutSlide();
    const mood = root.querySelector('.mood');
    if (mood) { const r = mood.getBoundingClientRect(), span = mood.offsetHeight - vh; mood.style.setProperty('--z', span > 0 ? clamp(-r.top / (span * 0.8), 0, 1).toFixed(3) : '1'); }
    root.querySelectorAll('section > .ribbon, footer > .ribbon, .w-pin > .ribbon').forEach(rb => {
      const r = rb.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      rb.style.setProperty('--ry', (-(r.top / vh) * 30).toFixed(1) + 'px');
    });
  }
  function watch() {
    const items = root.querySelectorAll('.rv, .ribbon, .swipe'), lifts = root.querySelectorAll('.lift');
    if (reduce.matches || !('IntersectionObserver' in window)) { items.forEach(n => n.classList.add('in')); lifts.forEach(n => n.classList.add('in')); return; }
    // the samples headline lightens once it is well into view, not the moment it peeks in
    const lio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); lio.unobserve(e.target); } }), { rootMargin: '0px 0px -35% 0px' });
    lifts.forEach(n => lio.observe(n));
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' });
    items.forEach(n => { if (!n.closest('.menu')) io.observe(n); });
  }
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; frame(); }); } }, { passive: true });
  // Chapter 3: three screens (title, text, facts). Each scroll inside the held section plays one slide to the next screen,
  // and a slide always runs to the end (about 1.1s); scrolling back up steps back the same way. On a mouse or trackpad the
  // wheel is held while a slide runs and until that scroll gesture has died away, so one gesture moves one screen. Touch
  // screens can't be held, so there a new swipe (a fresh touch) is needed for each step.
  const AB = { step: 0, last: 2, busy: false, acc: 0, y: scrollY, ms: 1100, hold: false, wheelAt: 0, touch: 0, used: -1, input: '' };
  function setAbout(step, animate) {
    const sec = root.querySelector('.about'); if (!sec || AB.step === step) return;
    AB.step = step; AB.acc = 0;
    if (!animate) { sec.classList.add('a-now'); sec.style.setProperty('--as', step); sec.offsetWidth; sec.classList.remove('a-now'); return; }
    AB.busy = true; AB.hold = true; AB.used = AB.touch; sec.style.setProperty('--as', step);
    setTimeout(() => { AB.busy = false; aboutSlide(); }, AB.ms);
  }
  function aboutPinned() {
    const pin = root.querySelector('.a-pin'); if (!pin) return false;
    const r = pin.getBoundingClientRect(), t = topPx();
    return r.top <= t + 2 && r.bottom >= innerHeight - 2;
  }
  function aboutSlide() {
    const sec = root.querySelector('.about'), pin = sec && sec.querySelector('.a-pin');
    const dy = scrollY - AB.y; AB.y = scrollY;
    if (!pin || reduce.matches || sec.classList.contains('a-flat')) return;
    const r = pin.getBoundingClientRect(), t = topPx(), vh = innerHeight;
    // only a new gesture counts towards the next slide: a fresh touch on touch screens, or a wheel gesture that started
    // after the last one died away (Firefox's smooth scrolling and a trackpad's glide keep moving the page after a slide starts)
    const fresh = AB.input === 'touch' ? AB.touch !== AB.used : (!AB.hold || performance.now() - AB.wheelAt > 180);
    if (AB.busy || !fresh) AB.acc = 0;
    else { if (dy && Math.sign(dy) !== Math.sign(AB.acc)) AB.acc = 0; AB.acc += dy; }
    if (AB.busy) return;
    if (r.top > vh) return setAbout(0, false);              // not reached yet: waiting on the title
    if (r.bottom < 0) return setAbout(AB.last, false);      // scrolled past: the facts are showing
    if (aboutPinned()) {
      if (AB.acc > 24 && AB.step < AB.last && r.top < t - 2) setAbout(AB.step + 1, true);
      else if (AB.acc < -24 && AB.step > 0) setAbout(AB.step - 1, true);
    }
    else if (r.top > t + 2 && AB.step > 0 && dy < 0) setAbout(0, true);                 // came back up past the start in one go
    else if (r.bottom < vh - 2 && AB.step < AB.last && dy > 0) setAbout(AB.last, true);  // went down past the end in one go
  }
  addEventListener('wheel', e => {
    const now = performance.now(), gap = now - AB.wheelAt; AB.wheelAt = now; AB.input = 'wheel';
    if (!aboutPinned()) { AB.hold = false; return; }
    if (AB.busy || (AB.hold && gap < 180)) { e.preventDefault(); return; }   // still the gesture that started the slide
    AB.hold = false;
  }, { passive: false });
  addEventListener('touchstart', () => { AB.touch++; AB.input = 'touch'; }, { passive: true });
  function fitAbout() {
    const sec = root.querySelector('.about'); if (!sec) return;
    sec.classList.remove('a-flat');
    const stage = sec.querySelector('.a-stage'), bar = root.querySelector('.bar');
    const room = stage.clientHeight - (bar ? bar.offsetHeight : 72) - 24;
    sec.classList.toggle('a-flat', [...sec.querySelectorAll('.a-in')].some(n => n.offsetHeight > room));
  }
  addEventListener('resize', () => { layoutGallery(); fitAbout(); frame(); });

  // links to a piece move the gallery instead of jumping into it
  root.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#piece-"]'); if (!a) return;
    e.preventDefault(); history.replaceState(null, '', a.getAttribute('href')); goPiece(a.getAttribute('href').slice(7));
  });
  function applyHash() {
    const h = decodeURIComponent(location.hash.slice(1));
    if (h.startsWith('edit-') && D.edits.some(e => e.slug === h.slice(5))) setEdit(h.slice(5));
    else if (h.startsWith('piece-')) goPiece(h.slice(6), true);
  }

  // the samples photo changes every 3 seconds while it is on screen
  let smpCycler = null;   // lets frame() change the photo part way through the held stretch
  function cycleSamples() {
    const box = root.querySelector('.s-img.cycle'); if (!box || reduce.matches || !('IntersectionObserver' in window)) return;
    const imgs = [...box.querySelectorAll('img')]; let k = 0, t = null;
    // the photos wait (loading=lazy) until the chapter is a screen away, then all load, so each is ready for its turn
    const near = new IntersectionObserver(es => { if (es[0].isIntersecting) { imgs.forEach(i => { i.loading = 'eager'; }); near.disconnect(); } }, { rootMargin: '100% 0px' });
    near.observe(box);
    // the outgoing photo stays solid underneath while the next one fades in over it, so nothing shows through mid-fade
    const next = () => { imgs.forEach(i => i.classList.remove('was')); imgs[k].classList.replace('on', 'was'); k = (k + 1) % imgs.length; imgs[k].classList.add('on'); };
    new IntersectionObserver(es => { const vis = es[0].isIntersecting; if (vis && !t) t = setInterval(next, 3000); else if (!vis && t) { clearInterval(t); t = null; } }).observe(box);
    smpCycler = () => { next(); if (t) { clearInterval(t); t = setInterval(next, 3000); } };   // change now, and restart the 3-second count
  }

  // the beige box behind a photo is only there while it loads: left in place, it shows as a thin pale line along
  // the photo's edge whenever the photo zooms or sits between pixels
  function settle() {
    root.querySelectorAll('.trio img, .frame img').forEach(img => {
      const box = img.closest('.trio > figure, .frame'), done = () => box.classList.add('ld');
      img.complete && img.naturalWidth ? done() : img.addEventListener('load', done, { once: true });
    });
  }

  uprightPhone.addEventListener('change', () => {
    const v = root.querySelector('.hero video'), sEl = v && v.querySelector('source'), [f, p] = heroFilm();
    if (!sEl || sEl.getAttribute('src') === f) return;
    v.poster = p; sEl.setAttribute('src', f); v.load(); if (!reduce.matches) v.play().catch(() => {});
  });

  render(); settle(); setupGallery(); watch(); watchVideos(); cycleSamples(); fitAbout(); frame();
  if (document.fonts) document.fonts.ready.then(() => { fitAbout(); frame(); });   // the text's height depends on the web fonts
  if (location.hash) setTimeout(applyHash, 60);
  addEventListener('hashchange', applyHash);
})();
